<template>
  <el-container class="LibraryDialog">
    <el-main class="p-0">
      <div>
        <ATable
          ref="table"
          v-loading="loading"
          :data="items"
          :placeholder="placeholder"
          :search_field="search_field"
          :disable_insert="data.length < 1 || !has_grant_write"
          border
          hide-button-excel
          @clicked-create="handleClickedCreate"
          @cell-click="handleCellClick"
        >
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex"
            :width="$width.index"
          />
          <el-table-column prop="name" label="이름" width="200" />
          <el-table-column prop="desc" label="비고" show-overflow-tooltip="" />
          <el-table-column label="명령" width="180">
            <template slot-scope="scope">
              <el-button
                size="mini"
                :disabled="data.length < 1 || !has_grant_write"
                @click="handleClickUpdate(scope.row)"
                >갱신</el-button
              >
              <el-button
                size="mini"
                :disabled="!has_grant_write"
                @click="handleClickModify(scope.row)"
                >수정</el-button
              >
              <el-button
                type="danger"
                size="mini"
                :disabled="!has_grant_write"
                @click="handleClickDelete(scope.row)"
                >삭제</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="modified_user_name"
            :label="$t('lang.modified_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="modified_at"
            :label="$t('lang.modified_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <div slot="right-bottom">
            <el-button class="close-button" @click="handleClickClose"
              >{{ $t("button.close") }} (Esc)</el-button
            >
          </div>
        </ATable>
      </div>
    </el-main>
    <el-dialog
      :title="title"
      top="50"
      width="400px"
      custom-class="form-dialog"
      destroyOnClose
      :close-on-click-modal="false"
      :visible.sync="dialog_visible"
      :modal="false"
    >
      <LibraryForm
        v-if="dialog_visible"
        :data="selected_data"
        :type_flag="type_flag"
        @deleted="handleClickDelete"
        @completed="handelCompletedForm"
      />
    </el-dialog>
  </el-container>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import LibraryForm from "./LibraryForm";

export default {
  name: "LibraryDialog",
  mixins: [form_container],
  components: { LibraryForm },
  data() {
    return {
      title: this.$t("title.library"),
      search_field: ["name", "desc"],
      placeholder: "이름, 비고",
      items: [],
      loading: false,
      selected_data: {},
      dialog_visible: false,
    };
  },
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      },
    },
    type_flag: {
      type: String,
      default: "1",
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.api.listLibrary(this.type_flag).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }
        this.items = res.data;
      });
    },
    doUpdate() {
      let data = Object.assign(this.selected_data);
      data.details = this.data;
      this.api.updateLibrary(data).then((res) => {
        this.handleResponse(res, this.$t("message.success_update"));
      });
    },
    doDelete() {
      this.api.deleteLibrary(this.selected_data).then((res) => {
        this.handleResponse(res, this.$t("message.success_delete"));
        this.handelCompletedForm();
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (!this.has_grant_write) {
        return;
      }
      this.selected_data = {
        id: 0,
        name: "",
        desc: "",
        details: this.data,
      };
      this.dialog_visible = true;
    },
    handleClickRow(data) {
      this.$emit("select", data);
    },
    handleCellClick(item, column) {
      if (!column.property) {
        return;
      }
      this.$emit("select", item);
    },
    handleClickUpdate(data) {
      this.selected_data = Object.assign({}, data);
      this.util.confirm(this, this.title, "갱신하시겠습니까?", this.doUpdate);
    },
    handleClickModify(data) {
      this.selected_data = Object.assign({}, data);
      this.dialog_visible = true;
    },
    handleClickDelete(data) {
      this.selected_data = Object.assign({}, data);
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleClickClose() {
      this.$emit("completed");
    },
    handelCompletedForm(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.loadData();
    },
  },
};
</script>
